import * as angular from 'angular';

/**
 * apply focus to an element based on a condition
 * optionally it can be used with aptAutofocusManager on a parent element
 * to autofocus on multiple elements
 */
export default function AutoFocusIfDirective($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    require: ['?^^aptAutofocusManager'], // optional use of aptAutofocusManager
    link: function ($scope, $element, $attrs, $ctrls) {
      let $el = angular.element($element);
      let focusManagerCtrl = $ctrls[0];

      $attrs.$observe('aptAutofocusIf', (val) => {
        const parsedVal = $scope.$eval(val);

        if (parsedVal) {
          $timeout(() => {
            if (focusManagerCtrl != null) {
              // when using with aptAutofocusManager to manage focus for multiple elements
              focusManagerCtrl.setFocus($el);
            } else {
              // when controlling focus for a single element
              $el.focus();
            }
          }, 1000);
        }
      });
    }
  };
}
